angular.module('impactx.search').component('ixInkBar', {
        require: {
            cardContainerCtrl: '^?ixCardTabContainer',
            listContainerCtrl: '^?ixListTabContainer'
        },
        controller: 'InkBarCtrl',
        templateUrl: 'modules/search/templates/ink-bar.tmpl.html'
    }
);